import './scss/styles.scss';
import productSpotlight from './js/product-spotlight';

productSpotlight.init('.js-component');



// WEBPACK FOOTER //
// ./src/entry.js